/*
* 车辆信息组件
* zxw
* 创建时间：
* 修改时间：2026-07-09
*/

import {
    theme,
    Flex,
    Modal,
    Button,
    Tag,
    Statistic,
} from 'antd';
import {
    Html2pdf,
    BrandUrl,
    SloganUrl,
} from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

/**
 * 显示车辆信息
 * @param {*} props 
 * @returns 
 */
const CarInfo = (props) => {
    const { open, setOpen, record, preGroup } = props;

    const {
        token: {
            colorPrimaryBg,
        },
    } = theme.useToken();

    const cancel = () => { setOpen(false); };
    const printer = () => {
        var printContents = document.getElementById('print-info-id').innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    };
    const download = () => { Html2pdf('print-info-id', record.number, ''); };

    return (
        <>
            <Modal
                width={820}
                style={{ top: 0 }}
                closable={false}
                open={open}
                keyboard={true}
                maskClosable={true}
                onCancel={cancel}
                footer={[
                    <Button key='back' onClick={cancel}>取消</Button>,
                    <Button key='printer' type='primary' onClick={printer}>打印</Button>,
                    <Button key='link' type='primary' onClick={download} style={{ marginRight: 20 }}>下载</Button>,
                ]}
            >
                <div id='print-info-id'>
                    <div className='print-info' style={{ padding: '0 30px' }}>
                        <Flex justify='space-between' style={{ marginBottom: '10px' }}>
                            <img src={BrandUrl} height='35px' alt={preGroup || CNF.companyShortName} />
                            <img src={SloganUrl} height='35px' alt={preGroup || CNF.companyShortName} />
                        </Flex>
                        <table width='100%'>
                            <thead align='center'>
                                <tr>
                                    <th colSpan='24'><h2>车辆信息表</h2></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>车牌号码:</td><td colSpan='8' style={{ width: 240 }}>{record.license_number}</td>
                                    <td colSpan='4' style={{ width: 120 }}>车辆名称:</td><td colSpan='8' style={{ width: 240 }}>{record.name}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>车辆型号:</td><td colSpan='8' style={{ width: 240 }}>{record.model}</td>
                                    <td colSpan='4' style={{ width: 120 }}>购买时间:</td><td colSpan='8' style={{ width: 240 }}>{record.purchase_time}</td>
                                </tr>
                                <tr><td colSpan='4' style={{ width: 120 }}>当前里程:</td><td colSpan='20' style={{ width: 600 }}>
                                    <Tag color={colorPrimaryBg}>
                                        <Statistic precision={0} suffix='km' valueStyle={{ fontSize: CNF.fontSize - 2, color: global.THEMECOLOR }} value={record.current_mileage} />
                                    </Tag>
                                </td>
                                </tr>
                                <tr><td colSpan='4' style={{ width: 120 }}>驾驶人:</td><td colSpan='20' style={{ width: 600 }}>{record.driver_displayname}</td></tr>
                                <tr><td colSpan='4' style={{ width: 120 }}>用途:</td><td colSpan='20' style={{ width: 600 }}>
                                    {record.uses && record.uses.split('\n').map((item, index) => {
                                        return <p key={index} style={{ margin: 0 }}>{item}</p>;
                                    })}
                                </td></tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>创建者:</td><td colSpan='8' style={{ width: 240 }}>{record.create_displayname}</td>
                                    <td colSpan='4' style={{ width: 120 }}>创建时间:</td><td colSpan='8' style={{ width: 240 }}>{record.create_time}</td>
                                </tr>
                                <tr><td colSpan='4' style={{ width: 120 }}>备注:</td><td colSpan='20' style={{ width: 600 }}>
                                    {record.description && record.description.split('\n').map((item, index) => {
                                        return <p key={index} style={{ margin: 0 }}>{item}</p>;
                                    })}
                                </td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default CarInfo